import { Select } from '@driftt/tide-core-legacy'
import { List } from 'immutable'
import IconSVG from 'svg-inline-react'

import plusIconSrc from '!svg-inline?removeTags=true!images/svg/plus.svg'
import closeIconSrc from '!svg-inline?removeTags=true!images/svg/close.svg'

const SelectsContainer = ({ options, onChange, value, className, placeholder, creatable = false, getValueDisplay = x => x }) => (
  <div className={className}>
    <div>
      {(value || List.of('')).map((innerValue, index) => (
        <div className="flex" style={{ marginBottom: 10 }} key={index}>
          <Select
            key={index}
            clearable={false}
            value={value.get(index) === '' ? null : { value: value.get(index), label: getValueDisplay(value.get(index)) }}
            onChange={event => event && onChange(value.set(index, event.value))}
            placeholder={placeholder}
            options={options}
            creatable={creatable}
          />
          {index === 0 ? (
            <IconSVG src={plusIconSrc} onClick={() => onChange(value.push(''))} />
          ) : (
            <IconSVG src={closeIconSrc} onClick={() => onChange(value.delete(index))} />
          )}
        </div>
      ))}
    </div>
  </div>
)

export default SelectsContainer



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/TargetingDisplay/SelectsContainer.js